import React from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {translatePath} from "../../uitls/RouteInterceptor";

// Internal link with a real href, so search engines can follow it and middle-click / open in new tab work.
// The path is written with the Dutch route names and translated to the current language, like RouteInterceptor does.
export default function AppLink({to, ...props}) {
    const language = useSelector(state => state.appLanguageRS);
    return <Link to={translatePath(to, language)} {...props}/>;
}
